import React from 'react';
import './Header.css'

const Header = () => {
    return (
        <div className='header'>
            <h1>Creative Software Co.</h1>
            <h6>We are hiring top web developers for our software company.</h6>
            <h3>Total Salary Budget: 200000 BDT</h3>
        </div>
    );
};

export default Header;